import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import styled from 'styled-components';

const Banner = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 8px;
  background: var(--mid-blue);
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  z-index: 1000;
  box-sizing: border-box;
`;

const ENABLED: boolean = false;

export const PSABanner = () => {
  const location = useLocation();
  const isExport = location.pathname.includes('/projects/export');

  if (!ENABLED || isExport) {
    return null;
  }

  return (
    <Banner>
      <FormattedMessage id="psaBanner.message" />
    </Banner>
  );
};
